<template>
  <div class="overHeight" style="display: flex; flex-direction: column">
    <div
      style="
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 88;
        left: 0;
        top: 2.5vw;
      "
    >
      <div class="changeWrap">
        <!-- <img :src="$images.change" alt="" /> -->
        <!-- <span>切换</span> -->
      </div>
      <div style="display: flex; align-items: center">
        <img
          @click="toIndex()"
          :src="(homePage == '梅林首页') ? $images.logory : $images.logo"
          style="width: 3vw; height: 3vw; cursor: pointer"
          alt=""
        />
        <Select
          style="width: 100px"
          placeholder="请选择年份"
          class="myselect"
          v-model="year"
        >
          <Option :value="item" v-for="item in arrYear" :key="item">{{
            item
          }}</Option>
        </Select>
        <Select
          style="width: 100px"
          placeholder="Select Month"
          class="myselect"
          v-model="month"
        >
          <Option :value="item" v-for="item in arrMonth" :key="item">{{
            item
          }}</Option>
        </Select>
        <Button
          @click="choseYearMonth()"
          type="warning"
          ghost
          style="
            cursor: pointer;
            margin-left: 15px;
            color: #bf9d63;
            border: solid 1px #bf9d63;
          "
        >
          {{
            $route.params.companyname == "Bright Food Asia Pacific Pty Ltd." ||
            $route.params.companyname == "Salov S.p.A"
              ? "Complete"
              : "完成"
          }}
        </Button>
      </div>
    </div>

    <div class="headListWrap" v-if="$route.params.riskname !== 'EBITDA'">
      <div class="headList swiper-container" style="width: 98%">
        <div class="swiper-wrapper">
          <div
            @click="changeRiskName(item.name)"
            :class="'swiper-slide itemHead' + (item.isActive ? ' active' : '')"
            v-for="item in listHead"
            :key="item.name"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div>
      <el-button
        @click="leftMenuShow = !leftMenuShow"
        type="warning"
        icon="el-icon-s-grid"
        circle
        style="
          position: fixed;
          left: 0vw;
          top: 2vw;
          cursor: pointer;
          top: 8vw;
          z-index: 5;
        "
      ></el-button>
    </div>
    <Row
      v-if="$route.params.riskname != '营运资金风险noNeed'"
      :gutter="16"
      class="page6 overHeight listLeft"
      style="flex: 1; overflow-y: hidden; display: flex"
    >
      <Col
        span="4"
        v-if="
          suitname !== '廉洁指数' &&
          ($route.params.riskname !== 'EBITDA' ||
            $route.params.companyname == '光明食品亚太有限公司' ||
            $route.params.companyname == 'Bright Food Asia Pacific Pty Ltd.') &&
          leftMenuShow
        "
      >
        <Collapse v-model="CollapseValue">
          <Panel :name="index" v-for="(item, index) in listLeft" :key="index">
            <div style="line-height: 1">
              {{ index }}
            </div>
            <div
              v-if="
                lightTop &&
                !(
                  index == 'EBITDA' ||
                  index == '外汇敞口' ||
                  index == '套保有效性' ||
                  index == '汇兑损益' ||
                  index == 'FX Exposure' ||
                  index == 'Hedging Effectiveness' ||
                  index == 'FX Financial Impact'
                )
              "
              style="margin-left: auto"
            >
              <div class="greenDot" v-if="lightTop[index] == 0"></div>
              <div
                class="yellowDot"
                v-else-if="lightTop[index] > 0 && lightTop[index] < 99"
              ></div>
              <div class="redDot" v-else></div>
            </div>
            <template #content>
              <div
                @click="choseLeftItem(item2)"
                class="item"
                v-for="item2 in item"
                :key="item2['KRI指标名称']"
                :style="
                  currentCollapseValue == item2['KRI指标名称']
                    ? 'color:#BF9D63'
                    : ''
                "
              >
                <div style="width: 9vw">
                  {{ item2["KRI指标名称"] }}
                </div>
                <template
                  v-if="
                    !(
                      item2['KRI指标名称'].indexOf('应收账款总览页') > -1 ||
                      item2['KRI指标名称'].indexOf('存货总览页') > -1 ||
                      item2['KRI指标名称'].indexOf('Inventory Overview') > -1 ||
                      item2['KRI指标名称'].indexOf(
                        'Account Receivables Overview'
                      ) > -1 ||
                      item2['KRI指标名称'].indexOf('EBITDA（业务单元）') > -1 ||
                      item2['KRI指标名称'].indexOf('EBITDA（业务类型）') > -1 ||
                      item2['KRI指标名称'].indexOf('净销售收入下钻分析') > -1 ||
                      item2['KRI指标名称'].indexOf('销售成本下钻分析') > -1 ||
                      item2['KRI指标名称'].indexOf('外汇敞口') > -1 ||
                      item2['KRI指标名称'].indexOf(
                        '套保汇率与预算汇率的偏离度'
                      ) > -1 ||
                      item2['KRI指标名称'].indexOf('汇兑损益变动金额') > -1 ||
                      item2['KRI指标名称'].indexOf('应收总览页') > -1 ||
                      item2['KRI指标名称'].indexOf('Pre-Hedging FX Exposure') >
                        -1 ||
                      item2['KRI指标名称'].indexOf(
                        'Hedging Deviation Against Budget Rate'
                      ) > -1 ||
                      item2['KRI指标名称'].indexOf('Exchange Gain/Loss') > -1 ||
                      item2['KRI指标名称'].indexOf('EBITDA by BU') > -1 ||
                      item2['KRI指标名称'].indexOf('EBITDA by Segment') > -1 ||
                      item2['KRI指标名称'].indexOf('Net Sales Breakdown') >
                        -1 ||
                      item2['KRI指标名称'].indexOf('COGS Breakdown') > -1
                    )
                  "
                >
                  <div class="greenDot" v-if="item2['状态'] == 0"></div>
                  <div
                    class="yellowDot"
                    v-else-if="item2['状态'] > 0 && item2['状态'] < 99"
                  ></div>
                  <div class="redDot" v-else></div>
                </template>
              </div>
            </template>
          </Panel>
          <div
            class="leftTwoBox"
            v-if="
              showLeftDes &&
              (choseLeftItemData['公式'] || choseLeftItemData['解释'])
            "
            @click="showLeftDes = false"
          >
            <div class="color1">
              {{ choseLeftItemData["公式"] }}
            </div>
            <div class="line"></div>
            <div class="color2">
              {{ choseLeftItemData["解释"] }}
            </div>
          </div>
        </Collapse>
      </Col>
      <Col
        v-if="suitname == '贸易合规风险'"
        :style="'overflow-x: hidden;' + leftMenuShow ? 'width:100%' : ''"
      >
        <div>
          <el-dialog
            class="platedialog"
            :title="relationTitle"
            top="0"
            :visible.sync="dialogVisible"
            width="100%"
          >
            <div class="echartRelate" style="height: 100vh">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                id="svgId"
                height="1000"
                width="100%"
              ></svg>
            </div>
            <span slot="footer" class="dialog-footer"> </span>
          </el-dialog>
          <div class="financingInner" style="width: 100%">
            <div class="part2" style="width: 100%">
              <div class="topList">
                <div class="item" v-for="item in contractTopList">
                  <div class="yellowCorner">
                    <div class="itemTitle" style="font-size: 0.7vw">
                      {{ item.name }}
                    </div>
                    <div class="content">
                      <span class="num" style="font-size: 1.3vw">{{
                        item.num
                      }}</span>
                      <span class="unit">{{ item.unit }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tableWrap" style="width: 100%; position: relative">
                <el-tag
                  style="
                    position: absolute;
                    right: 0vw;
                    top: -1vw;
                    width: 7vw;
                    height: 2.5vw;
                    line-height: 2.5vw;
                    text-align: center;
                    font-size: 1.2vw;
                    border: solid 3px #bf9d63;
                  "
                  type="warning"
                  plain
                  effect="plain"
                >
                  模拟数据
                </el-tag>
                <div class="yellowCorner overHeight" style="width: 100%">
                  <div class="tableList overHeight" style="width: 100%">
                    <div
                      class="titleWrap borderRight borderTop BorderBottom"
                      style="width: 100%"
                    >
                      <div style="width: 30%">
                        <div class="padding1 borderLeft borderRight" style="">
                          上游
                        </div>
                        <div style="display: flex; align-items: center">
                          <div
                            class="padding1 borderLeft borderTop borderRight borderBottom"
                            style="
                              width: 50%;
                              text-align: center;
                              font-size: 0.8vw;
                            "
                          >
                            供应商描述
                          </div>
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="
                              width: 50%;
                              text-align: center;
                              font-size: 0.8vw;
                            "
                          >
                            合同编号
                          </div>
                        </div>
                      </div>
                      <div style="width: 30%">
                        <div class="padding1 borderRight" style="width: 100%">
                          下游
                        </div>
                        <div style="display: flex; align-items: center">
                          <div
                            class="padding1 borderRight borderBottom borderTop"
                            style="
                              width: 50%;
                              text-align: center;
                              font-size: 0.8vw;
                            "
                          >
                            售达方名称
                          </div>
                          <div
                            class="padding1 borderRight borderBottom borderTop"
                            style="
                              width: 50%;
                              text-align: center;
                              font-size: 0.8vw;
                            "
                          >
                            合同编号
                          </div>
                        </div>
                      </div>
                      <div
                        class="padding1 borderRight borderBottom"
                        style="
                          display: flex;
                          align-items: center;
                          width: 5%;
                          height: 6vw;
                          flex-shrink: 0;
                        "
                      >
                        检查编号
                      </div>
                      <div style="width: 30%">
                        <div class="padding1 borderRight" style="width: 100%">
                          检查项目
                        </div>
                        <div style="display: flex; align-items: center">
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="width: 20%; text-align: center"
                          >
                            上游合同条款
                          </div>
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="width: 20%; text-align: center"
                          >
                            下游合同条款
                          </div>
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="width: 20%; text-align: center"
                          >
                            非实体仓库收发
                          </div>
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="width: 20%; text-align: center"
                          >
                            上游预付下游赊账
                          </div>
                          <div
                            class="padding1 borderTop borderRight borderBottom"
                            style="width: 20%; text-align: center"
                          >
                            关联关系
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          width: 5%;
                          height: 6vw;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        class="borderBottom"
                      >
                        是否预警
                      </div>
                    </div>
                    <div
                      v-for="item in paginatedData"
                      class="titleWrap borderRight BorderBottom"
                      style="background: none; color: #fff; width: 100%"
                    >
                      <div style="width: 100%; box-sizing: border-box">
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            width: 100%;
                            box-sizing: border-box;
                          "
                        >
                          <div
                            class="padding1 borderLeft borderRight borderBottom"
                            style="
                              box-sizing: border-box;
                              width: 15%;
                              text-align: center;
                              font-size: 0.8vw;
                              font-weight: 400;
                            "
                          >
                            {{ item["供应商描述"] }}
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 15%; text-align: center"
                          >
                            <el-link
                              :underline="false"
                              target="_blank"
                              :href="
                                'https://community.gmfintl.com/brightfood_platform_pc/#/disfinancingtrade?filename=' +
                                item['上游合同名']
                              "
                              type="warning"
                              style="
                                color: #fff;
                                font-size: 0.8vw;
                                font-weight: 400;
                                text-decoration: underline;
                              "
                              >{{ item["上游合同编号"] }}</el-link
                            >
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="
                              width: 15%;
                              text-align: center;
                              font-size: 0.8vw;
                              font-weight: 400;
                            "
                          >
                            {{ item["售达方名称"] }}
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 15%; text-align: center"
                          >
                            <el-link
                              :underline="false"
                              target="_blank"
                              :href="
                                'https://community.gmfintl.com/brightfood_platform_pc/#/disfinancingtrade?filename=' +
                                item['下游合同名']
                              "
                              type="warning"
                              style="
                                color: #fff;
                                font-size: 0.8vw;
                                font-weight: 400;
                                text-decoration: underline;
                              "
                              >{{ item["下游合同编号"] }}</el-link
                            >
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="
                              width: 5%;
                              text-align: center;
                              flex-shrink: 0;
                            "
                          >
                            <el-popover
                              v-if="
                                JSON.stringify(item['检查编号']).indexOf('{') >
                                -1
                              "
                              :popper-options="{
                                boundariesElement: 'viewport',
                                removeOnDestroy: true,
                              }"
                              popper-class="popoverBackB"
                              placement="left"
                              width="400"
                              trigger="hover"
                            >
                              <div class="hoverContent">
                                <div class="hovertitle">
                                  {{ item["检查编号"]["listUp"]["question"] }}
                                </div>
                                <div class="content">
                                  {{ item["检查编号"]["listUp"]["answer"] }}
                                </div>
                              </div>
                              <div slot="reference" style="cursor: pointer">
                                {{ item["检查编号"].value }}
                              </div>
                            </el-popover>
                            <div v-else>{{ item["检查编号"] }}</div>
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 6%; text-align: center"
                          >
                            <el-popover
                              :popper-options="{
                                boundariesElement: 'viewport',
                                removeOnDestroy: true,
                              }"
                              popper-class="popoverBackB"
                              placement="left"
                              width="400"
                              trigger="hover"
                            >
                              <div class="hoverContent">
                                <div class="hovertitle">
                                  {{
                                    item["上游合同条款"]["listUp"]["question"]
                                  }}
                                </div>
                                <div class="content">
                                  {{ item["上游合同条款"]["listUp"]["answer"] }}
                                </div>
                              </div>
                              <div slot="reference" style="cursor: pointer">
                                {{ item["上游合同条款"]["value"] }}
                              </div>
                            </el-popover>
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 6%; text-align: center"
                          >
                            <el-popover
                              :popper-options="{
                                boundariesElement: 'viewport',
                                removeOnDestroy: true,
                              }"
                              popper-class="popoverBackB"
                              placement="left"
                              width="400"
                              trigger="hover"
                            >
                              <div class="hoverContent">
                                <div class="hovertitle">
                                  {{
                                    item["下游合同条款"]["listUp"]["question"]
                                  }}
                                </div>
                                <div class="content">
                                  {{ item["下游合同条款"]["listUp"]["answer"] }}
                                </div>
                              </div>
                              <div slot="reference" style="cursor: pointer">
                                {{ item["下游合同条款"]["value"] }}
                              </div>
                            </el-popover>
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 6%; text-align: center"
                          >
                            <el-popover
                              :popper-options="{
                                boundariesElement: 'viewport',
                                removeOnDestroy: true,
                              }"
                              popper-class="popoverBackB"
                              placement="left"
                              width="400"
                              trigger="hover"
                            >
                              <div class="hoverContent">
                                <div class="hovertitle">
                                  {{ item["疑似无货权"]["listUp"]["question"] }}
                                </div>
                                <div class="content">
                                  {{ item["疑似无货权"]["listUp"]["answer"] }}
                                </div>
                                <div class="line"></div>
                                <div class="hovertitle">
                                  {{
                                    item["疑似无货权"]["listMid"]["question"]
                                  }}
                                </div>
                                <div class="content">
                                  {{ item["疑似无货权"]["listMid"]["answer"] }}
                                </div>
                                <div class="line"></div>
                                <div class="hovertitle">
                                  {{
                                    item["疑似无货权"]["listDown"]["question"]
                                  }}
                                </div>
                                <div class="content">
                                  {{ item["疑似无货权"]["listDown"]["answer"] }}
                                </div>
                              </div>
                              <div slot="reference" style="cursor: pointer">
                                {{ item["疑似无货权"]["value"] }}
                              </div>
                            </el-popover>
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 6%; text-align: center"
                          >
                            <el-popover
                              :popper-options="{
                                boundariesElement: 'viewport',
                                removeOnDestroy: true,
                              }"
                              popper-class="popoverBackB"
                              placement="left"
                              width="400"
                              trigger="hover"
                            >
                              <div class="hoverContent">
                                <div class="hovertitle">
                                  {{ item["资金垫付"]["listUp"]["question"] }}
                                </div>
                                <div class="content">
                                  {{ item["资金垫付"]["listUp"]["answer"] }}
                                </div>
                                <div class="line"></div>
                                <div class="hovertitle">
                                  {{ item["资金垫付"]["listDown"]["question"] }}
                                </div>
                                <div class="content">
                                  {{ item["资金垫付"]["listDown"]["answer"] }}
                                </div>
                              </div>
                              <div slot="reference" style="cursor: pointer">
                                {{ item["资金垫付"]["value"] }}
                              </div>
                            </el-popover>
                          </div>
                          <div
                            class="padding1 borderRight borderBottom"
                            style="width: 6%; text-align: center"
                          >
                            <span
                              @click="
                                showSvg(item['关联关系']['relation'], item)
                              "
                              style="cursor: pointer"
                              >{{ item["关联关系"]["value"] }}</span
                            >
                          </div>
                          <div
                            class="padding1 borderBottom"
                            style="width: 5%; text-align: center"
                          >
                            {{ item["是否预警"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <el-pagination
                      style="text-align: right; margin-top: 1vw"
                      background
                      :current-page.sync="currentPage"
                      layout="prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :page-size="pageSize"
                      :total="total"
                      @size-change="handleSizeChange"
                      @current-change="handlePageChange"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col
        v-else
        :span="
          suitname !== '廉洁指数' &&
          ($route.params.riskname !== 'EBITDA' ||
            $route.params.companyname == '光明食品亚太有限公司' ||
            $route.params.companyname == 'Bright Food Asia Pacific Pty Ltd.')
            ? leftMenuShow
              ? 20
              : 24
            : 24
        "
        :style="'height:100%;'"
        v-show="iframeUrl"
      >
        <iframe
          v-if="showIframeFlag"
          :key="iframeUrl"
          :src="iframeUrl + '&p_company=' + $route.params.companyname"
          frameborder="0"
          scrolling="no"
          id="external-frame"
          style="width: 100%; height: 100%"
        ></iframe>
      </Col>
      <Col span="15" class="overHeight" v-if="false">
        <div class="right overHeight"></div>
      </Col>
    </Row>
    <Row class="page6 overHeight yyfx" :gutter="16" v-else>
      <div>
        <Col span="6">
          <div class="angle">
            <div class="angleSon">
              <div style="display: flex; align-items: center">
                <div class="dot"></div>
                <div
                  style="
                    padding-bottom: 10px;
                    font-weight: 500;
                    font-size: 1vw;
                    color: #bf9d63;
                  "
                >
                  应收账款坏账计提
                </div>
              </div>
              <div style="height: 8vw">
                <page8ring
                  id="bottom_1_1"
                  :data="data5"
                  ref="chart2"
                ></page8ring>
              </div>

              <div style="display: flex; align-items: center">
                <div class="dot"></div>
                <div
                  style="
                    padding-bottom: 10px;
                    font-weight: 500;
                    font-size: 1vw;
                    color: #bf9d63;
                  "
                >
                  应收账款账龄表
                </div>
              </div>
              <Table
                height="100"
                :columns="[
                  {
                    title: '账龄',
                    key: 'q1',
                  },
                  {
                    title: '未到账',
                    key: 'q2',
                  },
                  {
                    title: '0-30天',
                    key: 'q3',
                  },
                  {
                    title: '30-60天',
                    key: 'q4',
                  },
                  {
                    title: '90天以上',
                    key: 'q5',
                  },
                  {
                    title: '合计',
                    key: 'q6',
                  },
                ]"
                :data="[
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                ]"
              ></Table>
            </div>
          </div>
        </Col>
        <Col span="12">
          <div style="display: flex; align-items: center">
            <div class="dot"></div>
            <div style="font-weight: 500; font-size: 1.1vw; color: #bf9d63">
              现金循环周期
            </div>
          </div>
          <div style="text-align: center">
            <span style="font-size: 3vw; color: #fff; font-weight: bold"
              >35.7</span
            >
            <span style="color: #bf9d63; font-size: 0.2vw">天</span>
          </div>
          <div class="topbottomWrap">
            <div class="item">
              <div class="itemson1">应收账款天数</div>
              <div class="itemson2">29.1</div>
              <div class="itemson3">天</div>
            </div>
            <div class="item">
              <div class="itemson1">应收账款天数</div>
              <div class="itemson2">29.1</div>
              <div class="itemson3">天</div>
            </div>
            <div class="item">
              <div class="itemson1">存货天数</div>
              <div class="itemson2">29.1</div>
              <div class="itemson3">天</div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="angle">
            <div class="angleSon">
              <div style="display: flex; align-items: center">
                <div class="dot"></div>
                <div
                  style="
                    padding-bottom: 10px;
                    font-weight: 500;
                    font-size: 1vw;
                    color: #bf9d63;
                  "
                >
                  应收账款坏账计提
                </div>
              </div>
              <div style="height: 8vw">
                <page8ring
                  id="bottom_1_1"
                  :data="data5"
                  ref="chart2"
                ></page8ring>
              </div>

              <div style="display: flex; align-items: center">
                <div class="dot"></div>
                <div
                  style="
                    padding-bottom: 10px;
                    font-weight: 500;
                    font-size: 1vw;
                    color: #bf9d63;
                  "
                >
                  应收账款账龄表
                </div>
              </div>
              <Table
                height="100"
                :columns="[
                  {
                    title: '账龄',
                    key: 'q1',
                  },
                  {
                    title: '未到账',
                    key: 'q2',
                  },
                  {
                    title: '0-30天',
                    key: 'q3',
                  },
                  {
                    title: '30-60天',
                    key: 'q4',
                  },
                  {
                    title: '90天以上',
                    key: 'q5',
                  },
                  {
                    title: '合计',
                    key: 'q6',
                  },
                ]"
                :data="[
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                  {
                    q1: '鼎牛',
                    q2: 89.1,
                    q3: 96.2,
                    q4: 38.7,
                    q5: 20.4,
                    q6: 244.4,
                  },
                ]"
              ></Table>
            </div>
          </div>
        </Col>
      </div>
      <div class="bottomPart">
        <ring id="bottom_1_1" :data="data5" ref="chart1"></ring>
      </div>
    </Row>
  </div>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions, mapState } from "pinia";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import { queryChilidIndicatorDetails, queryContractList } from "../api/index";
const ring = () => import("./components/page1/page8");
const page8ring = () => import("./components/page1/page8_circle");
import { Loading } from "element-ui";
import relationJson from "./relation.json";
import * as d3 from "d3";
// ===== 绘图 =====
function drawMarker() {
  d3.select("svg")
    .append("svg:defs")
    .append("svg:marker")
    .attr("id", "blueMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", (d) => {
      return "#000000";
    });
  d3.select("svg")
    .select("defs")
    .append("svg:marker")
    .attr("id", "redMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", "#fd6568");
}

function drawCircle(id) {
  let circleG = d3.select(`#${id}`).attr("class", "circle-g");
  circleG
    .append("circle")
    .attr("class", "real-circle")
    .attr("fill", (d) => {
      // 某个企业详情页点击进来的，给个这个企业特殊样式
      if (d.isSelf) {
        return "#fe9d3b";
      }
      if (String(d.type).indexOf("important") > -1) {
        return "#fe5557";
      }
      if (String(d.type).indexOf("person") > -1) {
        return "#4d2fe1";
      }
      if (String(d.type).indexOf("Vendor") > -1) {
        return "#bf9d63";
      }
      if (String(d.type).indexOf("Customer") > -1) {
        return "#a79286";
      }
      return "#52a3eb";
    })
    .attr("stroke", function (d) {
      if (d.isSelf) {
        return "#ec8a2f";
      } else if (String(d.type).indexOf("person") > -1) {
        return "#0082e5";
      }
      return "none";
    })
    // 设置圆圈半径
    .attr("r", (d) => {
      if (String(d.type).indexOf("person") > -1) {
        return 23;
      }
      if (String(d.type).indexOf("important") > -1) {
        return 48;
      }
      return 35;
    });
}

function drawText(id) {
  d3.select(`#${id}`)
    .insert("text")
    .attr("class", "circle-text")
    .attr("dy", ".35em")
    .attr("text-anchor", "middle")
    .attr("font-size", 12)
    .style("fill", function (node) {
      return "#fff";
    })
    .attr("y", (d) => {
      return d.x;
    })
    .attr("x", function (d) {
      let re_en = /[a-zA-Z]+/g;
      //如果是全英文，不换行
      if (d.name.match(re_en)) {
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      }
      //如果小于四个字符，不换行
      else if (d.name.length <= 4) {
        d3.select(this)
          .append("tspan")
          .attr("x", -2)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      } else if (d.name.length > 4 && d.name.length <= 8) {
        //大于4  这两行
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot;
          });
      }
      // 文字长度大于8 折三行
      else if (d.name.length > 8 && d.name.length <= 12) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -15)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 16)
          .text(function () {
            return bot1;
          });
      }
      //文字长度大于12 折四行
      else if (d.name.length > 12 && d.name.length <= 16) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -20)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -3)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 23)
          .text(function () {
            return bot2;
          });
      } else if (d.name.length > 16) {
        //文字长度大于16  方案
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, 14);

        bot2 += "...";
        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -22)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 25)
          .text(function () {
            return bot2;
          });
      }
    });
}

function drawLinkPath(container, links) {
  // 添加连接路径path
  container
    .append("g")
    .attr("class", "line-path")
    .selectAll(".path")
    .data(links)
    .enter()
    .append("path")
    .attr("class", "path")
    .attr("fill", "none")
    .attr("stroke-dasharray", function (d) {
      if (String(d.type).indexOf("dash") > -1) {
        return 5.5;
      }
      return "none";
    })
    .attr("stroke-width", 1)
    .attr("stroke", function (d) {
      if (d.color) {
        return d.color;
      }
      return "#000000";
    })
    .attr("marker-end", function (d) {
      let id = "blueMarker";
      if (d.type === "投资") {
        id = "redMarker";
      }
      return `url(#${id})`;
    })
    .attr("cursor", "pointer");
}

function drawRelationText(container, links, linkGroup) {
  for (let i in linkGroup) {
    let edges_text = container
      .append("g")
      .attr("class", "relation-text")
      .selectAll(".linetext")
      .data(linkGroup[i])
      .enter()
      .append("svg:g")
      .attr("class", "linetext")
      .attr("fill-opacity", 1);

    edges_text
      .append("svg:text")
      .attr("font-size", 10)
      .attr("fill", "#8e8e8e")
      .attr("y", ".31em")
      .attr("dy", function (d, i) {
        return i + 1.5 + "em";
      })
      .attr("text-anchor", "middle")
      .text(function (d) {
        return d.value;
      });
  }
}

function formatNode(nodes) {
  let name = "";
  nodes.forEach((node) => {
    if (name === node.name) {
      node.isSelf = true;
    }
    node.idx = "zf" + uuid();
  });
}
// 格式化连接关系数据
function formatLink(links, nodes) {
  links.forEach((link, i) => {
    link.index = i;
    let src = nodes.find((node) => node.name == link.source);
    let dst = nodes.find((node) => node.name == link.target);
    link["source"] = src;
    link["target"] = dst;
  });
}
function uuid() {
  return Math.random().toString(34).replaceAll(/\,|\./g, "");
}

// ===== 更新 =====
function tick() {
  try {
    updateLinkLine();
    updateCircleAndText();
    updateLinkRelationText();
  } catch (error) {
    console.error("Error in tick:", error);
  }
}
function updateCircleAndText() {
  d3.selectAll("circle")
    .attr("cx", (d) => {
      return d.x;
    })
    .attr("cy", (d) => d.y);
  d3.selectAll(".circle-text").attr("transform", (d) => {
    return `translate(${d.x},${d.y})`;
  });
}
function updateLinkLine() {
  let edges_line = d3.selectAll(".path");
  edges_line.attr("d", function (d) {
    return (
      "M" +
      d.source.x +
      " " +
      d.source.y +
      " L " +
      d.target.x +
      " " +
      d.target.y
    );
  });
}
function updateLinkRelationText() {
  let svg = d3.select("svg");
  let edges_text = svg.selectAll(".linetext");

  //更新连接线上文字的位置
  edges_text.attr("transform", function (d) {
    let translateX = (d.source.x + d.target.x) / 2;
    let translateY = (d.source.y + d.target.y) / 2;
    return `translate(${translateX},${translateY}) rotate(0)`;
  });
}
export default {
  name: "page6",
  components: {
    ring,
    page8ring,
  },
  computed: {
    ...mapState(useDataStore, [
      "rightButtonValue",
      "title",
      "showLeftTop",
      "showRightTop",
      "backUrl",
      "showLeftTopAlways"
    ]),
    total() {
      return this.listAnswer.length;
    },
    paginatedData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      return this.listAnswer.slice(start, end);
    },
  },
  created() {
    this.setLeftTop(false);
    this.setLeftTopAlways(false);
    let userInfo = localStorage.getItem("bbsUserInfo");
      if (userInfo) {
        let userInfoJson = JSON.parse(userInfo);
        this.homePage = userInfoJson.homePage
      }
    // this.listAnswer = relationJson;
    if (this.$route.query.type == "domestic") {
      this.companyDomestic = "境内";
    } else {
      this.companyDomestic = "境外";
    }

    if (this.$route.params.companyname) {
      this.setTitle(this.$route.params.companyname);
    }
    
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (this.companyDomestic == "境内") {
      if (day <= 7) {
        if (month == 1) {
          month = 11;
          year--;
        } else if (month == 2) {
          month = 12;
          year--;
        } else {
          month = month - 2;
        }
      } else {
        if (month == 1) {
          month = 12;
          year--;
        } else {
          month--;
        }
      }
    } else {
      if (day <= 15) {
        if (month == 1) {
          month = 11;
          year--;
        } else if (month == 2) {
          month = 12;
          year--;
        } else {
          month = month - 2;
        }
      } else {
        if (month == 1) {
          month = 12;
          year--;
        } else {
          month--;
        }
      }
    }
    if (this.$route.params.companyname == "意大利SALOV公司") {
      //   month = 12;
      //   year = 2023;
    }
    if (month < 10) {
      month = "0" + month;
    }
    // if (this.$route.params.companyname == "光明食品亚太有限公司") {
    //   month = "10";
    // }

    this.year = year;
    this.month = month + "";
    if (this.$route.query.date && this.$route.query.date.indexOf(".") > -1) {
      let date = this.$route.query.date;
      let year = date.split(".")[0];
      let month = date.split(".")[1];
      this.year = Number(year);
      this.month = month;
    }
    let beforeYear = year - 50;
    let arrYear = [];
    while (beforeYear < year) {
      arrYear.push(year--);
    }
    arrYear = arrYear.filter((item) => item > 2020);
    this.arrYear = arrYear;
    let arrMonth = [];
    for (let i = 1; i <= 12; i++) {
      let month2 = i < 10 ? "0" + i : "" + i;
      arrMonth.push(month2);
    }
    this.arrMonth = arrMonth;
    this.getData();
    this.getConTractList();
  },
  watch: {
    // // 监听路由是否变化
    // $route(to, from) {
    //   if (to.query.key2 != from.query.key2) {
    //     const { key2, iframeurl } = to.query;
    //     this.listHead.forEach((item) => {
    //       if (item.name == key2) {
    //         item.isActive = true;
    //       } else {
    //         item.isActive = false;
    //       }
    //     });
    //     this.iframeUrl = iframeurl;
    //     this.choseYearMonth();
    //   }
    // },
    // "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=1",
  },
  data() {
    return {
      homePage:'',
      relationTitle: "关联关系图谱",
      leftMenuShow: false, //左边展示隐藏
      showIframeFlag: true,
      simulation: null,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      listAnswer: [],
      contractTopList: [
        {
          name: "采购合同数量",
          num: "0/？",
          unit: "个",
        },
        {
          name: "销售合同数量",
          num: "17/63+?",
          unit: "个",
        },
        {
          name: "关联关系交易对数量",
          num: "0/148+?",
          unit: "个",
        },
        {
          name: "上下游合同对异常数量",
          num: "0/63+?",
          unit: "个",
        },
        {
          name: "货权异常交易对数量",
          num: "0/148+？",
          unit: "个",
        },
        {
          name: "关联关系异常数量",
          num: "0/148+？",
          unit: "个",
        },
        {
          name: "预警数量",
          num: "0",
          unit: "个",
        },
      ],
      dialogVisible: false,
      fileList: [],

      lightTop: undefined,
      suitname: "",
      showLeftDes: true,
      choseLeftItemData: {},
      data1: {},
      data5: {
        title: "EBITDA",
        // position: ["5%", "14%"],
        // center: ["50%", "60%"],
        data: [
          {
            color: "#0DE4EE",
            value: 10,
          },
        ],
      },
      arrYear: [],
      year: "",
      month: "",
      iframeUrl: "",
      CollapseValue: [],
      currentCollapseValue: "",
      listLeft: {},
      companyDomestic: "境外",
      listLeft2: [
        {
          key: "存货效期管理指标",
          value: [
            {
              key: "临期存货量占比",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=1",
            },
            {
              key: "临期存货金额",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=1",
            },
            {
              key: "已过期的存货占存货总量比率",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=1",
            },
            {
              key: "已过期的存货金额",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=1",
            },
          ],
        },
        {
          key: "存货积压情况",
          value: [
            {
              key: "存货周转天数",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=2",
            },
          ],
        },
        {
          key: "物流费用情况",
          value: [
            {
              key: "第三方物流费用费率",
              value:
                "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/6900D05CDF613D0197E3F4D59569147?mode=embed&page=2",
            },
          ],
        },
      ],
      listHead: [],
    };
  },
  methods: {
    ...mapState(useDataStore, ["title"]),
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl","setLeftTopAlways"]),
    getConTractList() {
      if (this.suitname != "贸易合规风险") {
        return;
      }
      let year = this.year;
      let month = this.month;
      queryContractList({
        dateColumn: year + "-" + month,
        page: 1,
        pageSize: 99999,
      }).then((res) => {
        if (res.code == 200) {
          this.listAnswer = res.data["合同列表"].list;
          this.contractTopList.forEach((item) => {
            item["num"] = res.data[item["name"]];
          });
        }
      });
    },
    getSvgDetail(data) {
      d3.select("#svgId").selectAll("*").remove();
      // if(this.simulation){
      //   this.simulation.stop()
      // }
      let { nodes, links } = JSON.parse(JSON.stringify(data));
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      formatLink(links, nodes);
      formatNode(nodes);
      let linkGroup = {};
      links.forEach((item) => {
        let key = item.source.name + ":" + item.target.name;
        if (linkGroup[key]) {
          linkGroup[key].push(item);
        } else {
          linkGroup[key] = [item];
        }
      });
      console.log(linkGroup, 22);
      let linkGroup2 = {};
      for (let i in linkGroup) {
        let linkGroup2List = Object.keys(linkGroup2);
        let res = linkGroup2List.findIndex((item) => {
          let first1 = item.split(":")[0];
          let second1 = item.split(":")[1];
          let first2 = i.split(":")[0];
          let second2 = i.split(":")[1];
          return (
            (first1 == first2 && second1 == second2) ||
            (first1 == second2 && first2 == second1)
          );
        });
        if (res > -1) {
          linkGroup2[linkGroup2List[res]] = linkGroup2[
            linkGroup2List[res]
          ].concat(linkGroup[i]);
        } else {
          linkGroup2[i] = linkGroup[i];
        }
      }
      const simulation = d3
        .forceSimulation(nodes)
        .force("link", d3.forceLink(links).distance(180))
        .force("charge", d3.forceManyBody().strength(-400).distanceMax(150))
        .force("center", d3.forceCenter(width / 2, height / 2))
        .on("tick", tick);

      // 创建一个根容器，用于存放要画的图形
      let container = d3
        .select("#svgId")
        .append("g")
        .attr("class", "container");

      // 绘制连接线
      drawLinkPath(container, links);
      // 绘制关系文本
      drawRelationText(container, links, linkGroup2);
      // 绘制箭头
      drawMarker();
      // 圆圈和文字的外层g，可以在这个上面添加点击、hover事件
      let nodeSelection = container
        .append("g")
        .attr("class", "nodegroup")
        .selectAll(".node")
        .data(nodes)
        .enter()
        .append("g")
        .attr("id", (d) => {
          return d.idx;
        });

      // 遍历绘制圆圈和圆圈上的文本
      nodeSelection.each((d) => {
        drawCircle(d.idx);
        drawText(d.idx);
      });

      // ===== 拖拽 =====
      let dragFunc = d3
        .drag()
        .on("start", dragStarted)
        .on("drag", dragged)
        .on("end", dragend);

      dragFunc(nodeSelection);
      function dragStarted(d) {
        if (!d3.event.active) simulation.alphaTarget(0.01).restart();
        d.fx = d.x;
        d.fy = d.y;
      }
      function dragged(d) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
      }
      function dragend(d) {
        if (!d3.event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      }

      // ===== 缩放 =====
      initZoom();
      function initZoom() {
        let zoom = d3
          .zoom()
          .scaleExtent([0.6, 5])
          .on("zoom", () => {
            console.log(d3, 333);
            let transform = d3.event.transform;
            return container.attr(
              "transform",
              `translate(${transform.x},${transform.y})scale(${transform.k})`
            );
          });

        //动画持续时间
        container
          .transition()
          .duration(10)
          .call(zoom.transform, d3.zoomIdentity);
        d3.select("svg")
          .call(zoom)
          // 取消默认的双击放大事件
          .on("dblclick.zoom", null);
      }
    },
    showSvg(relation, item) {
      this.relationTitle =
        "上游：" + item["供应商描述"] + " 下游：" + item["售达方名称"];
      const _this = this;
      console.log(relation, "relation");
      if (relation) {
        var url = relation;
        // 申明一个XMLHttpRequest
        var request = new XMLHttpRequest();
        // 设置请求方法与路径
        request.open("get", url);
        // 不发送数据到服务器
        request.send(null);
        //XHR对象获取到返回信息后执行
        request.onload = function () {
          // 解析获取到的数据
          if (request.responseText) {
            var data = JSON.parse(request.responseText);
            _this.dialogVisible = true;
            _this.$nextTick(() => {
              _this.getSvgDetail(data);
            });
          } else {
            _this.$message.info("未发现10层内关联关系");
          }
        };
      } else {
        this.$message.info("未发现10层内关联关系");
      }
    },
    toIndex() {
      console.log(window.history);
      if (window.history.length <= 2) {
        this.$router.replace("/");
      } else {
        this.$router.back();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handlePageChange(val) {
      this.currentPage = val;
    },
    async getData() {
      // 获取子风险数据
      const res = await queryChilidIndicatorDetails({
        companyDomestic: this.companyDomestic,
        companyName: this.$route.params.companyname,
        risk: this.$route.params.riskname,

        topicName: this.$route.params.riskname,
      });
      if (res.code == 200) {
        this.data1 = res.data;
        this.listHead = (this.data1["风险列表"] || [])
          .filter((item2) => item2 != "EBITDA")
          .map((item) => {
            return {
              name: item,
              isActive: false,
            };
          });
        this.listLeft = this.data1["子风险数据"];
        let firstItem = false;
        for (let i in this.listLeft) {
          if (this.listLeft[i] && this.listLeft[i][0] && !firstItem) {
            firstItem = this.listLeft[i][0];
          }
        }
        this.suit();
        if (this.$route.query.kri) {
          firstItem = {
            page: this.$route.query.page,
            story_id: this.$route.query.story_id,
            KRI指标名称: this.$route.query.kri,
          };
        }
        this.choseLeftItem(firstItem);
        this.showLeftDes = true;
        this.choseLeftItemData = firstItem;
        this.lightTop = {};
        for (let i in this.listLeft) {
          let count = 0;
          this.listLeft[i].forEach((item) => {
            count += Number(item["状态"]);
          });
          this.lightTop[i] = count;
        }
        this.$nextTick(() => {
          new Swiper(".swiper-container", {
            slidesPerView: "auto",
            // 如果需要分页器
            pagination: ".swiper-pagination",
            // 如果需要前进后退按钮
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
          });
        });
      }
    },
    suit(name) {
      if (name) {
        this.listHead.forEach((item) => {
          if (item.name == name) {
            item.isActive = true;
          } else {
            item.isActive = false;
          }
        });
        this.suitname = name;
      } else {
        this.listHead.forEach((item) => {
          if (item.name == this.$route.params.riskname) {
            item.isActive = true;
          } else {
            item.isActive = false;
          }
        });
        this.suitname = this.$route.params.riskname;
      }
    },
    async changeRiskName(name) {
      // 获取子风险数据
      const res = await queryChilidIndicatorDetails({
        companyDomestic: this.companyDomestic,
        companyName: this.$route.params.companyname,
        risk: name,

        topicName: name,
      });
      if (res.code == 200) {
        this.listLeft = res.data["子风险数据"];
        let firstItem = false;
        for (let i in this.listLeft) {
          if (this.listLeft[i] && this.listLeft[i][0] && !firstItem) {
            firstItem = this.listLeft[i][0];
          }
        }
        this.suit(name);

        this.choseLeftItem(firstItem, name);
        this.showLeftDes = true;
        this.choseLeftItemData = firstItem;

        this.lightTop = {};
        for (let i in this.listLeft) {
          let count = 0;
          this.listLeft[i].forEach((item) => {
            count += Number(item["状态"]);
          });
          this.lightTop[i] = count;
        }
      }
    },
    choseYearMonth() {
      let loading = Loading.service({
        lock: true,
        text: "",
        background: "rgba(0, 0, 0, 0.01)",
      });
      if (this.iframeUrl && this.iframeUrl.indexOf("p_yearMonth") > -1) {
        this.iframeUrl =
          this.iframeUrl.substring(0, this.iframeUrl.length - 6) +
          this.year +
          this.month;
      } else if (this.iframeUrl) {
        this.iframeUrl =
          this.iframeUrl + "&p_yearMonth=" + this.year + this.month;
      }
      setTimeout(() => {
        loading.close();
      }, 1500);
      this.getConTractList();
    },
    toNewIfram() {},
    toIframe(key1, key2) {
      let data = {
        意大利SALOV公司: {
          流动性风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/AE0130194BFD894D3FD99EF70CB9D04?mode=embed",
          食品安全风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/4AE0130194BFAB14C8987F8E7E2C64C2?mode=embed",
          人力资源管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/92E8130194B91CACFFF4957A022C8930?mode=embed",
          投资管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/E2E8130194B83277D2DFC3C30C61CACB?mode=embed",
          汇率风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/82E8130194B82AC51561D6C77CE9B2A5?mode=embed",
          法律纠纷与诉讼风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/AE8130194B833FFC86CF9DD4028CF8A?mode=embed",
          原材料采购风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/DAE0130194BE3483DA563AEB8E7A052F?mode=embed",
          存货管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/4BF80A05D6EFAF978B58B0EE4A94F373?mode=embed",
          应收账款风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/7BF80A05D6EF832C60C0B5260C154AD1?mode=embed",
          经营绩效风险: "XXX",
          廉洁指数:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/73F80A05D6E846B766CBFE5C12C53E8A?mode=embed",
          EBITDA:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/5160230194B87C54B315851002157476?mode=embed",
        },
        香港万安公司: {
          EBITDA:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/BBF80A05D6E81B2828C3146CEBC51187?mode=embed",
          流动性风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/5AE0130194BC74D2E399314B83C2640A?mode=embed",
          食品安全风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/8AE0130194BC2C2DB3523AB1A84D45E4?mode=embed",
          人力资源管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/A2E0130194BD735A6CF8846BDCFEA120?mode=embed",
          投资管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/32E0130194BD4C5733F699B41EDD08AB?mode=embed",
          汇率风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/F2E0130194BC864A96C8BA76FB1C7051?mode=embed",
          法律纠纷与诉讼风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/BAE0130194BCE94F6A8DC523F204D9A4?mode=embed",
          原材料采购风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/DB401B0194BE81146367898963BF3FE9?mode=embed",
          存货管理风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/49A80B0194B81A7BE812C1562A9217D5?mode=embed",
          应收账款风险:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/73F80A05D6EC8D007A52EF30ADFCA125?mode=embed",
          经营绩效风险: "XXX",
          廉洁指数:
            "https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/story/BBF80A05D6E81B2828C3146CEBC51187?mode=embed",
        },
      };
      try {
        if (data[key1][key2].indexOf("http") > -1) {
          this.$router.replace({
            path: "/page6",
            query: {
              key1,
              key2,
              iframeurl: data[key1][key2],
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    jump(page) {
      this.$router.push(page);
    },
    choseLeftItem(item, name) {
      console.log(item, "item");
      //   this.iframeUrl = item.page
      //     ? item.page
      //     : "" + item.storyId
      //     ? item.storyId
      //     : "";
      if (!item.story_id) {
        if (this.suitname != "贸易合规风险") {
          this.$message.warning("暂无数据");
        }
        this.iframeUrl = "";
      } else {
        if (
          this.$route.params.companyname == "意大利SALOV公司" ||
          this.$route.params.companyname == "香港万安公司" ||
          this.$route.params.companyname == "光明国际"
        ) {
          let userInfo = localStorage.getItem("bbsUserInfo");
          if (userInfo) {
            if (
              JSON.parse(userInfo).homePage == "子公司首页" &&
              this.suitname == "食品安全风险"
            ) {
              if (item["风险领域"] == "舆情") {
                item.page = "page=2";
              }
            }
          }
          if (
            JSON.parse(userInfo).homePage == "子公司首页" ||
            JSON.parse(userInfo).homePage == "多个子公司" ||
            JSON.parse(userInfo).homePage == "梅林首页"
          ) {
            if (this.suitname == "食品安全风险" && item["风险领域"] == "舆情") {
              item.page = "page=2";
            }
          }

          this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/app.html#/story2?shellMode=embed&/s2/${item.story_id}?${item.page}`;
          // this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/${item.story_id}?mode=embed&${item.page}`;
        } else {
          // this.iframeUrl = `https://ymspjt-q.cn40.analytics.sapcloud.cn/sap/fpa/ui/app.html#/story2&/s2/story2&/s2/${item.story_id}?mode=embed&${item.page}`;
          let { companyname, riskname } = this.$route.params;
          if (this.suitname) {
            riskname = this.suitname;
          }
          if (
            ((companyname == "梅林有限" || companyname == "梅林绵阳") &&
              (riskname == "采购管理风险" ||
                riskname == "生产管理风险" ||
                riskname == "仓储与物流管理风险")) ||
            (companyname == "鼎牛饲料" &&
              (riskname == "仓储与物流管理风险" ||
                riskname == "营运资金风险")) ||
            (companyname == "梅林罐分" &&
              (riskname == "仓储与物流管理风险" || riskname == "营运资金风险"))
          ) {
            let userInfo = localStorage.getItem("bbsUserInfo");
            if (userInfo) {
              if (
                JSON.parse(userInfo).homePage == "子公司首页" &&
                this.suitname == "食品安全风险"
              ) {
                if (item["风险领域"] == "舆情") {
                  item.page = "page=2";
                }
              }
            }
            if (
              JSON.parse(userInfo).homePage == "子公司首页" ||
              JSON.parse(userInfo).homePage == "多个子公司" ||
              JSON.parse(userInfo).homePage == "梅林首页"
            ) {
              if (
                this.suitname == "食品安全风险" &&
                item["风险领域"] == "舆情"
              ) {
                item.page = "page=2";
              }
            }
            // this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/${item.story_id}?mode=embed&${item.page}`;
          this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/app.html#/story2?shellMode=embed&/s2/${item.story_id}?${item.page}`;

          } else {
            let userInfo = localStorage.getItem("bbsUserInfo");
            if (userInfo) {
              if (
                JSON.parse(userInfo).homePage == "子公司首页" &&
                this.suitname == "食品安全风险"
              ) {
                if (item["风险领域"] == "舆情") {
                  item.page = "page=2";
                }
              }
            }
            if (
              JSON.parse(userInfo).homePage == "子公司首页" ||
              JSON.parse(userInfo).homePage == "多个子公司" ||
              JSON.parse(userInfo).homePage == "梅林首页"
            ) {
              if (
                this.suitname == "食品安全风险" &&
                item["风险领域"] == "舆情"
              ) {
                item.page = "page=2";
              }
            }
            // this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/bo/application/${item.story_id}?mode=embed&${item.page}`;
            this.iframeUrl = `https://shanghai-yimin-no-1.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/c7a59/app.html#/story2?shellMode=embed&/s2/${item.story_id}?${item.page}`;

            // this.iframeUrl = `https://ymspjt-q.cn40.analytics.sapcloud.cn/sap/fpa/ui/tenants/53cf4/bo/story/${item.story_id}?mode=embed&${item.page}`;
          }
        }
        if (this.$route.query.type == "domestic") {
          this.iframeUrl +=
            this.iframeUrl + "&p_company=" + this.$route.params.companyname;
        }
      }

      this.choseYearMonth();
      this.currentCollapseValue = item["KRI指标名称"];
      this.showLeftDes = true;
      this.choseLeftItemData = item;
      console.log(this.iframeUrl, "最后的iframe");
    },
    setIframeHeight() {
      const width = document.body.clientWidth;
      const myIframe = document.getElementById("external-frame");
      myIframe.style.height = width / 2.51 + "px";
    },
  },
  mounted() {
    this.setLeftTop(false);
    this.setLeftTopAlways(false);
  },
  destoryed() {},
  beforeDestroy() {
    this.setLeftTop(true);
    this.setLeftTopAlways(true);
    
  },
};
</script>
<style lang="less">
.yyfx {
  display: flex;
  flex-direction: column;
  .topbottomWrap {
    display: flex;
    justify-content: space-around;
    .item {
      width: 10vw;
      padding: 0.5vw;
      background: rgba(87, 87, 87, 0.5);
      .itemson1 {
        font-size: 1.1vw;
        color: #bf9d63;
      }
      .itemson2 {
        color: #fff;
        font-size: 1.5vw;
      }
      .itemson3 {
        text-align: right;
        font-size: 0.4vw;
        color: #bf9d63;
      }
    }
  }
  .bottomPart {
    flex: 1;
  }
  .ivu-table-cell {
    padding-left: 3px;
    padding-right: 3px;
  }
  .ivu-table-wrapper {
    border: none;
    // border: solid 1px rgb(74, 78, 82);
  }
  .ivu-table {
    //表格背景，字体颜色
    color: white;
    background-color: transparent;
    font-size: 0.2vw;
  }

  .ivu-table:before,
  .ivu-table:after {
    //表格背景
    background-color: transparent;
  }

  .ivu-table td,
  .ivu-table th {
    //行、列背景，行高
    height: 25px;
    background-color: transparent;
  }
  .ivu-table-header {
    background: rgb(70, 72, 74);
  }
  .ivu-table-header th {
    //表头背景
    background-color: transparent;
  }

  .ivu-table-overflowX {
    //是否显示滚动条
    // overflow-x: hidden;
  }

  .ivu-table td.table-info-column {
    //自定义列的颜色；需要配合column使用
    background-color: transparent;
    color: #fff;
  }

  .ivu-table-fixed {
    background-color: transparent;
    color: #fff;
  }

  .ivu-progress-inner {
    background: transparent;
  }
}
.listLeft {
  // #bf9d63
  color: #fff;
  //   color: rgb(142, 212, 221);

  .ivu-collapse-content {
    border: none;
    color: #fff;
    background: transparent;
    padding: 0 20px 0 60px;
    // color: rgb(142, 212, 221);
  }
  .ivu-collapse {
    border: none;
    border: 1px solid #4d4a48 !important;
    color: #fff;
    // color: rgb(142, 212, 221);

    background: rgba(87, 87, 87, 0.3);
    padding: 20px 0;
    height: 100%;
  }
  .ivu-collapse-content-box {
    padding-bottom: 0;
  }
  .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
    border: none;

    color: #fff;
    // color: rgb(142, 212, 221);

    display: flex;
    align-items: center;
    padding: 0 20px;
  }
  .ivu-collapse > .ivu-collapse-item {
    border: none;

    color: #fff;
    // color: rgb(142, 212, 221);

    // background: rgba(87, 87, 87, 0.3);
  }
}
.swiper-button-prev {
  background-image: url("../assets/images/lr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.swiper-button-next {
  background-image: url("../assets/images/rr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.myselect {
  margin-left: 15px;
  .ivu-select-selected-value {
  }
  .ivu-select-selection {
    color: #bf9d63;
    background-color: transparent;
    border: 1px solid #bf9d63;
  }
  .ivu-select-placeholder {
    color: #bf9d63 !important;
  }
}
</style>
<style lang="less" scoped>
.leftTwoBox {
  cursor: pointer;
  border: 1px solid #4d4a48;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 90%;
  margin: 0 auto;
  color: rgb(142, 212, 221);
  padding: 1vw;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  background: rgba(87, 87, 87, 0.5);
  .line {
    width: 100%;
    opacity: 0.20000000298023224;
    background: #fff;
    height: 1px;
    margin: 15px auto;
  }
  .color1 {
    color: #bf9d63;
    font-family: Microsoft YaHei;
    font-size: 0.6vw;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .color2 {
    color: #fff;
    font-family: Microsoft YaHei;
    font-size: 0.8vw;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
  }
}
.dot {
  margin-right: 10px;
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: linear-gradient(180deg, #bf9d63 0%, rgba(217, 217, 217, 0) 100%);
}
.greenDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
  background: #59cf7a;
  flex-shrink: 0;
}
.redDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e16a6a;
  flex-shrink: 0;
}
.yellowDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e4cc88;
  flex-shrink: 0;
}
.listLeft {
  background-color: transparent;
  font-size: 14px;

  .item {
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    &.active {
      // color: #bf9d63;
      .greenDot {
        background: rgba(225, 106, 106, 1);
      }
    }
  }
}
.changeWrap {
  display: flex;
  align-items: center;
  padding-left: 80px;
  position: relative;
  z-index: 20;
  img {
    width: 16px;
    cursor: pointer;
  }
  span {
    cursor: pointer;
    padding-left: 5px;
    font-size: 14px;
    color: #bf9d63;
  }
}
.headListWrap {
  //   width: 100%;
  //   overflow-x: auto;
  position: relative;
  z-index: 15;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
}
.headList {
  //   margin-top: 15px;
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  align-items: center;
  .itemHead {
    padding-left: 1vw;
    padding-right: 1vw;
    min-width: 11%;
    width: auto;
    margin-right: 1.6vw;
    height: 2.4vw;
    background: rgba(87, 87, 87, 0.3);
    border: 1px solid #4d4a48;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-size: 1vw;
    color: #ffffff;
    opacity: 0.6;
    cursor: pointer;

    &.active {
      opacity: 1;
      background: #bf9d63;
      border: 1px solid #4d4a48;
      color: #ffffff;
    }
  }
}
.page6 {
  height: 100%;
  width: 100%;
  padding-top: 25px;
  padding-left: 30px;
  padding-right: 30px;
  .right {
    height: 100%;
    background: rgba(87, 87, 87, 0.3);
  }
  .center {
    height: 100%;
    .item {
      border-right: solid 3px #000;
      border-bottom: solid 3px #000;
      padding: 15px;
      background: rgba(87, 87, 87, 0.3);
      color: #fff;
      > .line1 {
        color: #fff;
        .line1 {
          font-size: 14px;
        }
        .line2 {
          font-size: 12px;
        }
      }
      > .line2 {
        margin-bottom: 15px;
        margin-top: 15px;
        font-size: 50px;
        font-weight: 700;
        text-align: center;
      }
      > .line3 {
        display: flex;
        align-content: center;
        justify-content: space-between;
      }
    }
  }
  .left {
    font-size: 18px;
    height: 100%;
    padding-right: 40px;
    > .item {
      margin-bottom: 10px;
    }
    .father {
      .son {
        .item {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            color: #fff;
            padding-left: 28px;
          }
          .dot {
            background: #eb4b3e;
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
        }
      }
      .titleWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .titleWrapLeft {
          display: flex;
          align-items: center;
        }
        .name {
          color: #fff;
          padding-left: 8px;
        }
        .dot {
          background: #eb4b3e;
          width: 14px;
          height: 14px;
          border-radius: 50%;
        }
        .icon {
          position: relative;
          bottom: 3px;
          /* 用border值来控制箭头粗细 */
          border: 2px solid #1163a2;
          /* 上、右、下、左  四个边框的宽度 */
          border-width: 0px 1px 1px 0px;

          display: inline-block;
          /* padding值控制箭头大小 */
          padding: 5px;
          &.up {
            transform: rotate(-135deg);
            -webkit-transform: rotate(-135deg);
          }

          &.down {
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
          }
        }
        .son {
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.financingInner {
  .changeWrap {
    display: flex;
    align-items: center;
    padding-left: 80px;
    position: relative;
    z-index: 20;
    img {
      width: 16px;
      cursor: pointer;
    }
    span {
      cursor: pointer;
      padding-left: 5px;
      font-size: 14px;
      color: #bf9d63;
    }
  }
  .hoverContent {
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(147, 147, 153, 0.5);
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    .hovertitle {
      color: #fff;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 10px;
    }
    .line {
      margin: 10px auto;
      height: 1px;
      flex-shrink: 0;
      opacity: 0.14;
      background: #fff;
    }
    .content {
      color: #b3b3b3;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .padding1 {
    //   padding-top: 0.5vw;
    //   padding-bottom: 0.5vw;
    height: 3vw;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .borderLeft {
    border-left: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderTop {
    border-top: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderRight {
    border-right: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderBottom {
    border-bottom: solid 2px rgba(87, 87, 87, 0.5);
  }
  .part2 {
    .tableWrap {
      background: #2c3136;
      height: 60vh;
      margin-top: 1.5vw;
      font-weight: 600;
      border: solid 2px rgba(87, 87, 87, 0.5);

      .tableList {
        overflow-x: hidden;
        text-align: center;
        .titleWrap {
          display: flex;
          align-items: center;
          background: rgba(87, 87, 87, 0.5);
          color: #bf9d63;
        }
        .tableContentRow {
          display: flex;
          align-items: center;
          border-right: solid 2px rgba(87, 87, 87, 0.5);
          border-left: solid 2px rgba(87, 87, 87, 0.5);
          border-bottom: solid 2px rgba(87, 87, 87, 0.5);

          .tableItem {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            height: 2vw;
            width: 8vw;
            border-right: solid 2px rgba(87, 87, 87, 0.5);
          }
        }
      }
    }
    .topList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        width: 10vw;
        height: 7vw;
        flex-shrink: 0;
        border: 1px solid #4d4a48;
        background: rgba(87, 87, 87, 0.3);
        display: inline-block;
        .itemTitle {
          color: #bf9d63;
          font-family: Microsoft YaHei;
          font-size: 0.7vw;
          font-weight: 600;
        }
        .content {
          margin-top: 0.6vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .num {
            color: #fff;
            font-family: Microsoft YaHei;
            font-size: 1.8vw;
            font-style: normal;
            font-weight: 700;
            opacity: 0.8;
          }
          .unit {
            font-size: 0.8vw;
          }
        }
      }
    }
  }
  .content1 {
    color: #fff;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .content2 {
    color: #bf9d63;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .uploadButton {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 8vw;
    height: 2vw;
    font-size: 1vw;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid #bf9d63;
    background: #46423a;
    color: rgba(191, 157, 99, 1);
  }
  .yellowCorner {
    padding-left: 3%;
    padding-right: 4%;
    width: 100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding: 10px 20px;
  }
  .loadingWrap {
    margin-top: 12vh;
    text-align: center;
    .word {
      color: 999;
    }
  }
  .flow {
    height: 38vh;
    border: 1px solid #4d4a48;
    background: rgba(87, 87, 87, 0.3);
    display: flex;
    align-items: center;
    .yellowCorner {
      display: flex;
      align-items: center;
      padding: 3vh 3vw;
      padding-left: 1vw;
    }
    .flowLeft {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 7vw;
      .dot {
        border-radius: 50%;
        width: 0.5vw;
        height: 0.5vw;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
        margin-right: 0.5vw;
      }
      .word {
        color: #bf9d63;
        font-size: 1vw;
      }
    }
    .flowCenter {
      position: relative;
      width: 37vw;
      height: 100%;
      background: rgba(30, 34, 41, 1);
    }
    .flowRight {
      margin-left: 5vw;
      width: 37vw;
      height: 100%;
      background: rgba(30, 34, 41, 1);
      .noContent {
        text-align: center;
        margin-top: 12vh;
        .noword {
          color: #999;
        }
      }
    }
  }
  .top {
    height: 5vh;
    .left {
      color: #bf9d63;
      font-size: 1vw;
      float: left;
    }
    .right {
      float: right;
    }
  }
}
</style>